import React from 'react';
import {
  Icon, Spinner
} from '@blueprintjs/core';
import { inject, observer } from 'mobx-react';
import { formatTime } from '../../helpers/time';
import { EstimatePill } from 'components/Job/recordPills';
import JobEmpty from 'components/Job/JobEmpty';

const initialsOf = (name = '') =>
  String(name || '')
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((word) => word[0].toUpperCase())
    .join('');

@inject('viewStore', 'jobStore') @observer
class EstimatesTable extends React.Component {

  render() {
    let { 
      jobStore: {
        jobEstimates,
        jobAssociations: {
          isLoading
        }
      } 
    } = this.props
    const {
      viewStore
    } = this.props;
    if (isLoading) {
      return <div className="spinner-center"><Spinner size='25' /></div>
    }
    if (jobEstimates.length === 0) {
      return (
        <JobEmpty kind="estimates" />
      )
    }
    return (
      <div>
          {
            jobEstimates.map((estimate) => {
              return (
                <div className="tabs-data-card" key={estimate.id} onClick={() => {viewStore.ShowQuote({ uuid: estimate.attributes.id })}}>
                  <div className="card-style">
                    <div width="10px" className="customer-avatar">
                      <span className="jp-initials" aria-hidden="true">{initialsOf(estimate.attributes.created_by.full_name)}</span>
                    </div>
                    <div className="job-number" width="150px">
                      <p className="secondary">#{estimate.attributes.number}</p>
                      <p className="primary">By {estimate.attributes.created_by.full_name}</p>
                    </div>
		              </div>
                  <div className="job-details-status">
                    <div className="status-alignment">
                      <EstimatePill attributes={estimate.attributes} />
                    </div>
                    <div className="job-date-time">
                      {/* <p className='time-entry primary'>{this.calculateTotal(estimate)}</p> */}
                      <p className='secondary'>{ formatTime(estimate.attributes.created_at) }</p>
                    </div>
                  </div>
                  {/* <div>
                    <Icon icon="caret-right" />
                  </div> */}
                </div>
              )
            })
          }
        </div>
    )
  }
}

export default EstimatesTable;